// extracted by mini-css-extract-plugin
module.exports = {"button":"Costs_button__1tZK9","container":"Costs_container__4zUcd","total":"Costs_total__28R7t","rounding":"Costs_rounding__2wOiY"};